import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import _slicedToArray from "/app/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { API_REQUEST } from '@/api';
/**
 * @typedef {object} OverallResult
 * @property {boolean} [error]
 * @property {number} [newEmploymentId]
 * @property {Object<number,number>} [newWorkerWorkTypeIds]
 */

/**
 * Creates new employment
 * @param {import('@/store/store').StoreEmployment} employment
 */

export function createEmployment(_x) {
  return _createEmployment.apply(this, arguments);
}
/**
 * Updates existing employment
 * @param {import('@/store/store').StoreEmployment} employment
 */

function _createEmployment() {
  _createEmployment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(employment) {
    var overallResult, _yield$API_REQUEST, _yield$API_REQUEST2, error, result;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            overallResult = {};
            _context.next = 3;
            return API_REQUEST('createEmployment', employment);

          case 3:
            _yield$API_REQUEST = _context.sent;
            _yield$API_REQUEST2 = _slicedToArray(_yield$API_REQUEST, 2);
            error = _yield$API_REQUEST2[0];
            result = _yield$API_REQUEST2[1];

            if (error) {
              overallResult.error = true;
            } else if (result && result.id) {
              overallResult.newEmploymentId = result.id;
            } else if (result) {
              document.dispatchEvent(new CustomEvent('apiRequestError', {
                detail: {
                  error: 'Трудоустройство не создано (id)'
                }
              }));
            }

            return _context.abrupt("return", {
              employmentRes: result,
              overallResult: overallResult
            });

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createEmployment.apply(this, arguments);
}

export function updateEmployment(_x2) {
  return _updateEmployment.apply(this, arguments);
}
/**
 * Creates or updates existing employment
 * @param {import('@/store/store').StoreEmployment} employment
 */

function _updateEmployment() {
  _updateEmployment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(employment) {
    var overallResult, _yield$API_REQUEST3, _yield$API_REQUEST4, error, result;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            overallResult = {};
            _context2.next = 3;
            return API_REQUEST('updateEmployment', employment);

          case 3:
            _yield$API_REQUEST3 = _context2.sent;
            _yield$API_REQUEST4 = _slicedToArray(_yield$API_REQUEST3, 2);
            error = _yield$API_REQUEST4[0];
            result = _yield$API_REQUEST4[1];

            if (error) {
              overallResult.error = true;
            }

            return _context2.abrupt("return", {
              employmentRes: result,
              overallResult: overallResult
            });

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _updateEmployment.apply(this, arguments);
}

export function saveEmploymentMainInfo(_x3) {
  return _saveEmploymentMainInfo.apply(this, arguments);
}
/**
 * Saves employments constraints
 * @param {import('@/store/store').StoreEmployment} employment
 * @param {number} [newEmploymentId]
 */

function _saveEmploymentMainInfo() {
  _saveEmploymentMainInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(employment) {
    var _result, result;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!employment._isNew) {
              _context3.next = 5;
              break;
            }

            _context3.next = 3;
            return createEmployment(employment);

          case 3:
            _result = _context3.sent;
            return _context3.abrupt("return", _result);

          case 5:
            _context3.next = 7;
            return updateEmployment(employment);

          case 7:
            result = _context3.sent;
            return _context3.abrupt("return", result);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _saveEmploymentMainInfo.apply(this, arguments);
}

export function saveEmploymentConstraints(_x4, _x5) {
  return _saveEmploymentConstraints.apply(this, arguments);
}
/**
 *
 * @param {import('@/store/store').WorkTypeProcessed} workType
 * @param {number} [workTypeId]
 * @param {import('@/store/store').StoreEmployment} [employment]
 * @param {OverallResult} overallResult
 */

function _saveEmploymentConstraints() {
  _saveEmploymentConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(employment, newEmploymentId) {
    var overallResult, _yield$API_REQUEST5, _yield$API_REQUEST6, error;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            overallResult = {};
            _context4.next = 3;
            return API_REQUEST('saveEmploymentConstraints', {
              id: employment.id || newEmploymentId,
              data: employment._worker_constraints
            });

          case 3:
            _yield$API_REQUEST5 = _context4.sent;
            _yield$API_REQUEST6 = _slicedToArray(_yield$API_REQUEST5, 1);
            error = _yield$API_REQUEST6[0];

            if (error) {
              overallResult.error = true;
            }

            return _context4.abrupt("return", overallResult);

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _saveEmploymentConstraints.apply(this, arguments);
}

export function deleteEmploymentWorkType(_x6, _x7, _x8, _x9) {
  return _deleteEmploymentWorkType.apply(this, arguments);
}
/**
 *
 * @param {import('@/store/store').WorkTypeProcessed} workType
 * @param {number} [workTypeId]
 * @param {import('@/store/store').StoreEmployment} [employment]
 * @param {OverallResult} overallResult
 */

function _deleteEmploymentWorkType() {
  _deleteEmploymentWorkType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(workType, workTypeId, employment, overallResult) {
    var _yield$API_REQUEST7, _yield$API_REQUEST8, error;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return API_REQUEST('deleteEmploymentWorktype', {
              id: workType.absId
            });

          case 2:
            _yield$API_REQUEST7 = _context5.sent;
            _yield$API_REQUEST8 = _slicedToArray(_yield$API_REQUEST7, 1);
            error = _yield$API_REQUEST8[0];

            if (error) {
              overallResult.error = true;
            }

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _deleteEmploymentWorkType.apply(this, arguments);
}

export function updateEmploymentWorkType(_x10, _x11, _x12, _x13) {
  return _updateEmploymentWorkType.apply(this, arguments);
}
/**
 *
 * @param {import('@/store/store').WorkTypeProcessed} workType
 * @param {number} [workTypeId]
 * @param {import('@/store/store').StoreEmployment} [employment]
 * @param {OverallResult} overallResult
 */

function _updateEmploymentWorkType() {
  _updateEmploymentWorkType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(workType, workTypeId, employment, overallResult) {
    var _yield$API_REQUEST9, _yield$API_REQUEST10, error;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return API_REQUEST('updateEmploymentWorktype', {
              id: workType.absId,
              priority: workType.state,
              work_type_id: workTypeId,
              employment_id: employment.id
            });

          case 2:
            _yield$API_REQUEST9 = _context6.sent;
            _yield$API_REQUEST10 = _slicedToArray(_yield$API_REQUEST9, 1);
            error = _yield$API_REQUEST10[0];

            if (error) {
              overallResult.error = true;
            }

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _updateEmploymentWorkType.apply(this, arguments);
}

export function createEmploymentWorkType(_x14, _x15, _x16, _x17) {
  return _createEmploymentWorkType.apply(this, arguments);
}
/**
 * Performs CRUD operations with work types for the employment
 * @param {object} options
 * @param {import('@/store/store').StoreEmployment} options.employment
 * @param {Object<number, import('@/store/store').WorkTypeShort>} workTypesById
 * @param {OverallResult} options.overallResult
 * @param {string[]} options.workTypeIds
 */

function _createEmploymentWorkType() {
  _createEmploymentWorkType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(workType, workTypeId, employment, overallResult) {
    var _yield$API_REQUEST11, _yield$API_REQUEST12, error, result;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return API_REQUEST('createEmploymentWorktype', {
              priority: workType.state,
              work_type_id: workTypeId,
              employment_id: employment.id || overallResult.newEmploymentId
            });

          case 2:
            _yield$API_REQUEST11 = _context7.sent;
            _yield$API_REQUEST12 = _slicedToArray(_yield$API_REQUEST11, 2);
            error = _yield$API_REQUEST12[0];
            result = _yield$API_REQUEST12[1];

            if (error) {
              overallResult.error = true;
            } else {
              if (!overallResult.newWorkerWorkTypeIds) {
                overallResult.newWorkerWorkTypeIds = {};
              }

              overallResult.newWorkerWorkTypeIds[workTypeId] = result.id;
            }

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _createEmploymentWorkType.apply(this, arguments);
}

function saveWorkTypes(_x18) {
  return _saveWorkTypes.apply(this, arguments);
}
/**
 * Performs CRUD operations with work types for the employment
 * @param {import('@/store/store').StoreEmployment} employment
 * @param {Record<string, import('@/store/store').WorkTypeProcessed>} workTypesById
 * @param {OverallResult} overallResult
 */


function _saveWorkTypes() {
  _saveWorkTypes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref) {
    var workTypeIds, workTypesById, employment, overallResult, _iterator, _step, workTypeId, workType, _overallResult$employ;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            workTypeIds = _ref.workTypeIds, workTypesById = _ref.workTypesById, employment = _ref.employment, overallResult = _ref.overallResult;
            _iterator = _createForOfIteratorHelper(workTypeIds);
            _context8.prev = 2;

            _iterator.s();

          case 4:
            if ((_step = _iterator.n()).done) {
              _context8.next = 23;
              break;
            }

            workTypeId = _step.value;
            workType = workTypesById[workTypeId];

            if (!(workType.state === null)) {
              _context8.next = 13;
              break;
            }

            if (!workType.absId) {
              _context8.next = 11;
              break;
            }

            _context8.next = 11;
            return deleteEmploymentWorkType(workType, +workTypeId, employment, overallResult);

          case 11:
            _context8.next = 21;
            break;

          case 13:
            if (!workType.absId) {
              _context8.next = 18;
              break;
            }

            _context8.next = 16;
            return updateEmploymentWorkType(workType, +workTypeId, employment, overallResult);

          case 16:
            _context8.next = 21;
            break;

          case 18:
            if (overallResult !== null && overallResult !== void 0 && (_overallResult$employ = overallResult.employmentRes) !== null && _overallResult$employ !== void 0 && _overallResult$employ.work_types) {
              _context8.next = 21;
              break;
            }

            _context8.next = 21;
            return createEmploymentWorkType(workType, +workTypeId, employment, overallResult);

          case 21:
            _context8.next = 4;
            break;

          case 23:
            _context8.next = 28;
            break;

          case 25:
            _context8.prev = 25;
            _context8.t0 = _context8["catch"](2);

            _iterator.e(_context8.t0);

          case 28:
            _context8.prev = 28;

            _iterator.f();

            return _context8.finish(28);

          case 31:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[2, 25, 28, 31]]);
  }));
  return _saveWorkTypes.apply(this, arguments);
}

export function saveWorkTypesForEmployment(_x19, _x20, _x21) {
  return _saveWorkTypesForEmployment.apply(this, arguments);
}

function _saveWorkTypesForEmployment() {
  _saveWorkTypesForEmployment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(employment, workTypesById, overallResult) {
    var keysToProcessFirst, otherKeysToProcess;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            keysToProcessFirst = Object.keys(workTypesById).filter(function (el) {
              return workTypesById[el].state !== 1;
            });
            otherKeysToProcess = Object.keys(workTypesById).filter(function (el) {
              return !keysToProcessFirst.includes(el);
            });
            _context9.next = 5;
            return saveWorkTypes({
              workTypeIds: keysToProcessFirst,
              employment: employment,
              workTypesById: workTypesById,
              overallResult: overallResult
            });

          case 5:
            _context9.next = 7;
            return saveWorkTypes({
              workTypeIds: otherKeysToProcess,
              employment: employment,
              workTypesById: workTypesById,
              overallResult: overallResult
            });

          case 7:
            return _context9.abrupt("return", overallResult);

          case 10:
            _context9.prev = 10;
            _context9.t0 = _context9["catch"](0);
            console.error(_context9.t0);
            return _context9.abrupt("return", {});

          case 14:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 10]]);
  }));
  return _saveWorkTypesForEmployment.apply(this, arguments);
}